"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var migrations = {
  0: function _(state) {
    // clear user after OI-374 where favorites/recent became Immutable.Map
    return _objectSpread({}, state, {
      user: undefined
    });
  },
  2: function _(state) {
    // clear user ratings after OI-385 where ratings format changed
    return _objectSpread({}, state, {
      user: _objectSpread({}, state.user, {
        ratings: undefined
      })
    });
  }
};
var _default = migrations;
exports.default = _default;